export const videos = [
    {
        "title": "5_26_2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1n38N1mOS8JMN5ZUOZ3qt_dyLs2eQsm86"
    },
    {
        "title": "5_26_2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1NGkX6l7EbzCNXV7fxmXWIq1GGIuxDfXb"
    },
    {
        "title": "5_23_2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=12N-X3OXjs2RK4ZX_acE3zBzPyUN5iQlD"
    },
    {
        "title": "5_23_2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1kSAOP5cnmSaFw82qSxxmjt7f3c9FipNk"
    },
    {
        "title": "5_22_2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1sErmuUqcKxJfONdW__PE0NPgISYlSyeI"
    },
    {
        "title": "5_22_2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1cCeB9Fh4COpy1X3TXY2VvytLTtKq8Hna"
    },
    {
        "title": "5_21_2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1XMBALzxIm9XlX5Q6lsKkdAuy2RzqaB4U"
    },
    {
        "title": "5_21_2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1Y2Ykxpkqmy-XvbeWqKGTu1aE6_Y_k-IT"
    },
    {
        "title": "5_20_2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1ShHW4Qg4UXN8B1xZtEC1u6izbZ0L9bMc"
    },
    {
        "title": "5_20_2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1qt5x_vwTQUtx89SGXYA6eaTGl4rocV0C"
    },
    {
        "title": "5_19_2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1RDVk2flq2tdYtEATywFQkbLpxR-InHSz"
    },
    {
        "title": "5_19_2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=15_MG8lt4o3aSTKhARzdOOsaebMa7jj1c"
    },
    {
        "title": "5_17_2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1RDVk2flq2tdYtEATywFQkbLpxR-InHSz"
    },
    {
        "title": "5_17_2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=15_MG8lt4o3aSTKhARzdOOsaebMa7jj1c"
    },
    {
        "title": "5_16_2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1D-L4hracy3umY_j9biGpbWgieamSxIgf"
    },
    {
        "title": "5_16_2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1R2uSNjdUKnfjKq3OsNov0YwhiMTFRSkc"
    },
    {
        "title": "5-15-2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1D-L4hracy3umY_j9biGpbWgieamSxIgf"
    },
    {
        "title": "5-15-2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1R2uSNjdUKnfjKq3OsNov0YwhiMTFRSkc"
    },
    {
        "title": "5-14-2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1mc-mQ5KCMAurOphWs2q_JcNJEGfrhUMN"
    },
    {
        "title": "5-14-2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=170Xf-qJRM8g9kYcSkNIo-Zd64OLu9Vxa"
    },
    {
        "title": "5-13-2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1_A3XbLg4e4chJKMVquIZoxnMcULR07wv"
    },
    {
        "title": "5-13-2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1p6tGOlnYVHaFxhKoodCkgqPo3lYFkxBs"
    },
    {
        "title": "5-12-2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1OePPEb1L3q5kGGicW_lUFDKzZLYtfNDh"
    },
    {
        "title": "5-12-2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1GLPsW8VfNjT_ouYORCMjh_mkEZcjyroZ"
    },
    {
        "title": "5-09-2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=16jE3qMizbcPB_pLutCxFL66JP4LPOWY5"
    },
    {
        "title": "5-09-2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1ZNMbFMTcrTuErZgMq_z9W0DbiskQM47P"
    },
    {
        "title": "5-08-2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1LljWX001FMzlUVvXJeMy6R-cuOnT-TcD"
    },
    {
        "title": "5-08-2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1qVwutyLbsBW9MlFYKp9wQZ3jSDJrbMtC"
    },
    {
        "title": "5-07-2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1Y_kHbAY-V8Gwmy6bcF0Vk55IawIzfqCj"
    },
    {
        "title": "5-07-2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=18jG4xaAkDWXdmE-1qMJIX2BbfDLpvpwp"
    },
    {
        "title": "5-06-2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1dYWOFSsSixn7yfAxSP-HfK4riVBpLC88"
    },
    {
        "title": "5-06-2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1p-z9aeXY4ZZ8A-m1RdoKR4Dwf_Eo-htA"
    },
    {
        "title": "5-05-2025_2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1jVQuQWzRNvOm0ZFV23VDfA_LAmTuseQB"
    },
    {
        "title": "5-05-2025_1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1DaIEBthLSAv8Ed3_83Wonbw4WxP2Kfr8"
    },
    {
        "title": "35",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=15qHeCV4-88ErMXiNHukr_mnTn6Ay_d-5"
    },
    {
        "title": "34",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1ljQy9SMOW0K87JsepYzXnsilotwyi39k"
    },
    {
        "title": "33",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1iYCQ64ZfE-wPrwwcJQfFlcMe535y44zJ"
    },
    {
        "title": "32",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1Pl2J1wsW-0F0PbFoN9QlCD200aGvJAoV"
    },
    {
        "title": "31",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1_K0pgKqMeuwsoIz7ilrxbDI25c7gZIC6"
    },
    {
        "title": "30",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1GEjx4Syc2B59M7BOUdGHob6KHijZ8pFd"
    },
    {
        "title": "29",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1JGOPLDv2SQbCPZw-BrljwRN2ni-BQ0n5"
    },
    {
        "title": "28",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1wrCOb1lEnZw9TnDtX2FtY9gFnaDd7hjW"
    },
    {
        "title": "27",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1-0b0oxiO4spNLprrjsxh7CniZIrIFMWi"
    },
    {
        "title": "26",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1ri380wWQKStmaSuSK-CJNfkTJrnwBNBy"
    },
    {
        "title": "25",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1Gyw-PHDyp12FYMggwt98nQ-y8ewvzov2"
    },
    {
        "title": "24",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1zKs9FCnuqxR0fbvM0ZMXb4OO07Kh10QX"
    },
    {
        "title": "23",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1s6vZ0JqnOeF_Dklir5BPYjGXo96OjjP6"
    },
    {
        "title": "22",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1mVDmMva-yreDLoq2bkT9BWajavIwBjlF"
    },
    {
        "title": "21",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1IGi82Zorh_p5PMc9npR7jcvpsoXmiP67"
    },
    {
        "title": "20",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1OVrbfkiOOvx_rqgnWd0Igtooz-bgeNOV"
    },
    {
        "title": "19",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=10RrUO1146qbU5hx3ZJ0BAq4iPWpcEIsu"
    },
    {
        "title": "18",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1aDo7VsTKD6ioLOTofas5tCGazH4ko2Yj"
    },
    {
        "title": "17",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1gkRHWrxTtKCVtqdXdY2RqX_c6f4xLQdd"
    },
    {
        "title": "16",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1ifRD_Xvhnlnsw0ZOduJZoIqNARhuLnxT"
    },
    {
        "title": "15",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=14DvyjfIX4QcqmvYwP968HYHH5ZjIXo31"
    },
    {
        "title": "14",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1XBTLjxq1vH2QU7MNTZ1psPeHn3mmCeOG"
    },
    {
        "title": "13",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1Ewwv2i-8N6q34iwLhAAx3GMP8XRREGWS"
    },
    {
        "title": "12",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1kRb_mv0WYEDccKxQ97GCqWcxCBAPWgZI"
    },
    {
        "title": "11",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=19yvgJ3iog-GiecQcyPlEwlLESp6h29j4"
    },
    {
        "title": "10",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1qL19AqTpcKAvNFzKO_ib44QmW1UVyeIe"
    },
    {
        "title": "9",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1YK4_usmDqzWbDQ2S1TtOQn_Rn-PoU69J"
    },
    {
        "title": "8",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1pAWVgGLyo2Zvha0TIh9kOkatXd28cFWG"
    },
    {
        "title": "7",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=13ISgavJCboDDQ4oWsfETGa9z9mphWqIG"
    },
    {
        "title": "6",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1vzGcQxQylLy8gYAgK2A_f37L5s24tqSJ"
    },
    {
        "title": "5",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1is1Gc4HdPe7VOkv0WI6uqwknYj7oJUtY"
    },
    {
        "title": "4",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1FEnJKyio4kNyvYLXLR7rK-ilt-_5xC5G"
    },
    {
        "title": "3",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1SJRBf177U89i6B-yQ7_t-1_ZaSa6E1Gd"
    },
    {
        "title": "2",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1-ZLkG3IlNSjcxDHZ5cGYiGX379kYfCNL"
    },
    {
        "title": "1",
        "downloadUrl": "https://drive.google.com/uc?export=download&id=1uKTKr4-K7HdDRRar0gwEFrU5njydSIs6"
    }
];
